import Dexie from 'dexie';

export const db = new Dexie('project_database');

db.launchDB = () => {
    db.version(1).stores({
        projects: '++id, lowertitle'
    });
    db.version(2).stores({
        projects: '++id, lowertitle',
        palettes: '++id, lowertitle',
        settings: '++id' // singleton object
    });
    db.open().catch(function (err) {
        console.error(err.stack || err);
        b3.store.mySet('showLoadingErrorMessage', true);
    });
};

